export default from './InputText'


// WEBPACK FOOTER //
// ./src/components/InputText/index.js